import { map, keyBy, flow, mapValues, join, compact } from 'lodash/fp'

export const keyValArrayToObject = flow(keyBy('key'), mapValues('value'))

export const mapWithKey = (map as any).convert({ cap: false })

export const joinAndCompact = (items: (undefined | string | null)[]): string =>
  (flow as any)(compact, join(','))(items)



// WEBPACK FOOTER //
// src/utils/lodash.ts